module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("404 Page Not Found!")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d9e94844!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/FourOhFour.vue
// module id = 920
// module chunks = 2